/**
 * SNIPPET - NAVIGATION HORIZONTAL - LISTENERS
 */

setupEventListenersForHorizontalNavigation();

// Creates the event listeners
function setupEventListenersForHorizontalNavigation() {
  // On hovering on a fold-out menu item of a list
  document.querySelectorAll('.navigation-horizontal__list-item > .navigation-horizontal__list-link').forEach((element) => {
    element.addEventListener('mouseover', openNavigationHorizontalList);
  });
  
  // On hovering on a fold-out menu item of a dropdown
  document.querySelectorAll('.navigation-horizontal__dropdown-item--expandable > .navigation-horizontal__dropdown-link').forEach((element) => {
    element.addEventListener('mouseover', openNavigationHorizontalDropdown);
  });
  
  // On hovering on a link in a mega menu
  document.querySelectorAll('.dropdown-column__list-link[data-src]').forEach((element) => {
    element.addEventListener('mouseenter', changeNavigationHorizontalImage);
  });
}

/**
 * SNIPPET - NAVIGATION HORIZONTAL - GENERAL
 */

// Opens a submenu list
function openNavigationHorizontalList() {
  var target = event.currentTarget,
      headerBar = target.closest('.section__page.header-bar'),
      header = target.closest('.header'),
      itemsMenu = header.querySelectorAll('.navigation-horizontal__list-item'),
      itemMenu = target.closest('.navigation-horizontal__list-item'),
      dropdownMegaOver = itemMenu.querySelector('.navigation-horizontal__dropdown--mega-over'),
      colorActive = itemMenu.dataset.colorActive,
      filterActive = itemMenu.dataset.filterActive,
      stickyColumn = document.querySelector('.column--sticky-desktop'),
      cartItems = document.querySelector('.main').querySelectorAll('.list-cart-items:not([data-height-desktop="0"])');

  event.preventDefault();

  itemsMenu.forEach((element) => {
    var dropDownItemActive = element.querySelector('.navigation-horizontal__dropdown-item--active');
    
    element.classList.remove('navigation-horizontal__list-item--active');
    element.setAttribute('aria-expanded', 'false');
    
    if (dropDownItemActive !== null) {
      dropDownItemActive.classList.remove('navigation-horizontal__dropdown-item--active');
      dropDownItemActive.setAttribute('aria-expanded', 'false');
    }
  });

  if (itemMenu.classList.contains('navigation-horizontal__list-item--expandable')) {
    itemMenu.classList.toggle('navigation-horizontal__list-item--active');
    itemMenu.setAttribute('aria-expanded', itemMenu.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }

  if (dropdownMegaOver !== null) {
    headerBar.classList.add('header-bar--transparent');
    header.classList.add('header--with-mega-nav-opened');
    header.style.setProperty('--dropdown-filter-logo-active', filterActive);
    itemMenu.style.setProperty('--dropdown-color-text-active', colorActive);  
    if (stickyColumn !== null) stickyColumn.style.position = 'unset';    
    cartItems.forEach((element) => {
      element.style.overflow = 'unset';
    });
  } else {
    cartItems.forEach((element) => {
      element.style.overflow = 'auto';
    });
    if (stickyColumn !== null) stickyColumn.style.position = 'sticky';   
    header.classList.remove('header--with-mega-nav-opened');
    headerBar.classList.remove('header-bar--transparent');
  }

  document.addEventListener('mouseover', () => {
    if (event.target.closest('.section__page.header-bar') === null) {
      var dropDownItemActive = itemMenu.querySelector('.navigation-horizontal__dropdown-item--active');
      
      cartItems.forEach((element) => {
        element.style.overflow = 'auto';
      });
      if (stickyColumn !== null) stickyColumn.style.position = 'sticky';
      itemMenu.classList.remove('navigation-horizontal__list-item--active');
      itemMenu.setAttribute('aria-expanded', 'false');
      
      if (dropDownItemActive !== null) {
        dropDownItemActive.classList.remove('navigation-horizontal__dropdown-item--active');
        dropDownItemActive.setAttribute('aria-expanded', 'false');
      }
      
      header.classList.remove('header--with-mega-nav-opened');
      headerBar.classList.remove('header-bar--transparent');
    }
  });

  return false;
}

// Opens a submenu dropdown
function openNavigationHorizontalDropdown() {
  var target = event.currentTarget,
      itemMenu = target.closest('.navigation-horizontal__dropdown-item'),
      itemMenuSiblings = getSiblings(itemMenu),
      windowWidth = window.innerWidth,
      rightEdge = target.getBoundingClientRect().right,
      nestedMenus = itemMenu.closest('.navigation-horizontal__dropdown').querySelectorAll('.navigation-horizontal__dropdown'),
      shouldOpenLeft = false;

  event.preventDefault();

  itemMenu.classList.toggle('navigation-horizontal__dropdown-item--active');
  itemMenu.setAttribute('aria-expanded', itemMenu.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  itemMenuSiblings.forEach((element) => {
    element.classList.remove('navigation-horizontal__dropdown-item--active');
    element.setAttribute('aria-expanded', 'false');
  });

  // To avoid off-screen problems, all children are checked and if at least one of them goes off-screen, they are opened on the left instead
  nestedMenus.forEach((element) => {
    if ((rightEdge + itemMenu.offsetWidth) > windowWidth) {
      shouldOpenLeft = true;
      return false;
    }
  });

  if (shouldOpenLeft) {
    nestedMenus.forEach((element) => {
      element.classList.add('navigation-horizontal__dropdown--left');
    });
  } else {
    nestedMenus.forEach((element) => {
      element.classList.remove('navigation-horizontal__dropdown--left');
    });
  }

  return false;
}

// Changes the image of the mega menu
function changeNavigationHorizontalImage() {
  var target = event.currentTarget,
      mediaUrl = target.getAttribute('data-src').split('&width').shift(),
      dropdownMega = target.closest('.navigation-horizontal__dropdown--mega'),
      dropdownImageContainer = dropdownMega.querySelector('.navigation-horizontal__image'),
      dropdownImage = dropdownImageContainer.querySelector('img'),
      imageSrc = dropdownImage.getAttribute('src').split('&width').shift(),
      imageSrcSet = dropdownImage.getAttribute('srcset');

  event.preventDefault();
  imageSrcSet = imageSrcSet.replaceAll(imageSrc, mediaUrl);
  imageSrc = imageSrc.replace(imageSrc, mediaUrl);
  dropdownImage.setAttribute('srcset', imageSrcSet);
  dropdownImage.setAttribute('src', imageSrc);
}